import React, { useCallback, Fragment } from 'react';
import GaugeCard from '../entity/GaugeCard'
import { getStats } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'
import ColorPicker from 'components/pages/livefeed/Editor/EditorContainer/common/ColorPicker'

const Widgets = (props) => {
    const { dispatch, scaleMode, nodeMap, sensorMap, livefeedSlides, editorView, stepNumberState, slideCurrentIndex } = props
    const colorPickerRef = React.useRef(null);

    const { fontFamily, gauge0, gauge1, gauge2, floorplanOptions: { locationsID, isStandbyAsUnOccupied } } = livefeedSlides[slideCurrentIndex]

    let isAllAreas = undefined; let isMR = false; let isOA = false; // isMeetingRooms// isOpenAreas
    let stats = []
    // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed
    let refinedLocationsID = locationsID.filter(id => nodeMap[id])

    for (let i = 0, n = refinedLocationsID.length; i < n; i++) {
        if (refinedLocationsID[i] !== undefined) {
            let node = nodeMap[refinedLocationsID[i]]
            switch (node.type) {
                case "meeting_room":
                    isMR = true
                    stats.push(getStats(node, sensorMap, isStandbyAsUnOccupied))
                    break;
                case "open_area":
                    isOA = true
                    stats.push(getStats(node, sensorMap, isStandbyAsUnOccupied))
                    break;
            }
        }
        if (isOA && isMR) {
            isAllAreas = true
        } else {
            isAllAreas = false
        }
    }

    const renderGaugeCards = useCallback(() => {
        if (stats.length > 0) {
            let sumMr = 0; let sumOARooms = 0; let sumSensors = 0;
            let sumInUsedDesks = 0; let sumInUsedMr = 0; let sumInUsedOA = 0;
            for (let i = 0, n = stats.length; i < n; i++) {
                const { allSensors, allDesksInUse, meetingRooms, meetingRoomsInuse, openAreaRooms, openAreaRoomsInUse } = stats[i]
                sumMr += meetingRooms
                sumSensors += allSensors
                sumOARooms += openAreaRooms
                sumInUsedDesks += allDesksInUse
                sumInUsedMr += meetingRoomsInuse
                sumInUsedOA += openAreaRoomsInUse
            }

            // let totalRoomsValues = [50, 100]; // default
            let oaValues = [sumOARooms - sumInUsedOA, sumOARooms]
            let mrValues = [sumMr - sumInUsedMr, sumMr];
            let deskValues = [sumSensors - sumInUsedDesks, sumSensors]
            if (isAllAreas) {
                // totalRoomsValues = [(sumMr + sumOARooms) - (sumInUsedMr + sumInUsedOA), sumMr + sumOARooms];
                return (
                    <Fragment>
                        <GaugeCard
                            dispatch={dispatch}
                            scaleMode={scaleMode}
                            values={deskValues}
                            gauge={gauge0}
                            colorPickerRef={colorPickerRef}
                            title={gauge0.label}
                            livefeedSlides={livefeedSlides}
                            editorView={editorView}
                            slideCurrentIndex={slideCurrentIndex}
                            stepNumberState={stepNumberState}
                        />
                        {sumOARooms ?
                            <GaugeCard
                                dispatch={dispatch}
                                scaleMode={scaleMode}
                                values={oaValues}
                                gauge={gauge1}
                                colorPickerRef={colorPickerRef}
                                title={gauge1.label}
                                livefeedSlides={livefeedSlides}
                                editorView={editorView}
                                slideCurrentIndex={slideCurrentIndex}
                                stepNumberState={stepNumberState}
                            />
                            : <div />
                        }
                        {sumMr &&
                            <GaugeCard
                                dispatch={dispatch}
                                scaleMode={scaleMode}
                                values={mrValues}
                                gauge={gauge2}
                                colorPickerRef={colorPickerRef}
                                title={gauge2.label}
                                livefeedSlides={livefeedSlides}
                                editorView={editorView}
                                slideCurrentIndex={slideCurrentIndex}
                                stepNumberState={stepNumberState}
                            />
                        }
                    </Fragment>
                )
            }
            if (isMR) {
                return (
                    <Fragment>
                        {sumSensors &&
                            <GaugeCard
                                scaleMode={scaleMode}
                                dispatch={dispatch}
                                values={deskValues}
                                gauge={gauge0}
                                colorPickerRef={colorPickerRef}
                                title={gauge0.label}
                                livefeedSlides={livefeedSlides}
                                editorView={editorView}
                                slideCurrentIndex={slideCurrentIndex}
                                stepNumberState={stepNumberState}
                            />
                        }
                        {sumMr &&
                            <GaugeCard
                                scaleMode={scaleMode}
                                dispatch={dispatch}
                                values={mrValues}
                                gauge={gauge2}
                                colorPickerRef={colorPickerRef}
                                title={gauge2.label}
                                livefeedSlides={livefeedSlides}
                                editorView={editorView}
                                slideCurrentIndex={slideCurrentIndex}
                                stepNumberState={stepNumberState}
                            />
                        }

                    </Fragment>
                )
            }
            if (isOA) {
                return (
                    <Fragment>
                        {sumSensors &&
                            <GaugeCard
                                scaleMode={scaleMode}
                                dispatch={dispatch}
                                values={deskValues}
                                gauge={gauge0}
                                colorPickerRef={colorPickerRef}
                                title={gauge0.label}
                                livefeedSlides={livefeedSlides}
                                editorView={editorView}
                                slideCurrentIndex={slideCurrentIndex}
                                stepNumberState={stepNumberState}
                            />
                        }
                        {sumOARooms &&
                            <GaugeCard
                                dispatch={dispatch}
                                scaleMode={scaleMode}
                                values={oaValues}
                                gauge={gauge1}
                                colorPickerRef={colorPickerRef}
                                title={gauge1.label}
                                livefeedSlides={livefeedSlides}
                                editorView={editorView}
                                slideCurrentIndex={slideCurrentIndex}
                                stepNumberState={stepNumberState}
                            />
                        }

                    </Fragment>
                )

            }
        }
    }, [editorView, stepNumberState, gauge0, gauge1, gauge2, isAllAreas, scaleMode, dispatch, isMR, isOA, stats, livefeedSlides, slideCurrentIndex])

    return (
        <span style={{ fontFamily: fontFamily }}>
            {renderGaugeCards()}
            <ColorPicker ref={colorPickerRef} />
        </span>
    );
}


export default Widgets;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/Widgets/index.jsx